import Vue from 'vue'
import App from './App.vue'
// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vant from 'vant';
import 'vant/lib/index.css';
// 引入路由
import router from './router/router';
// 引入状态管理
import store from './vuex/store';
import { httphostCheck } from '@/api/userMG';

import { isMobile } from '@/utils/device';



import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

import axios from 'axios';
Vue.prototype.$axios = axios;

// 使用element UI
Vue.use(ElementUI);
Vue.use(Vant);


Vue.config.productionTip = false;



//响应回来
axios.interceptors.response.use(response => {
        if (response.data.code == 404) {
            if (router.currentRoute.path !== '/login') { // 添加路径检查
                ElementUI.Message({
                    message: '请登录后访问！',
                    type: 'err'
                });
                // const sessionStorageData = {};
                // for (let i = 0; i < sessionStorage.length; i++) {
                //     const key = sessionStorage.key(i);
                //     const value = sessionStorage.getItem(key);
                //     sessionStorageData[key] = value;
                // }
                //  console.log('sessionStorageData: ' + JSON.stringify(sessionStorageData));
                // const requestUrl = response.config.url;
                // const responseData = JSON.stringify(response.data, null, 2); // 格式化JSON数据
                //  console.log('main请登录后访问！\n' +
                //     '请求接口: ' + requestUrl + '\n' +
                //     '错误信息：' + responseData);
                sessionStorage.clear();
                router.push({ path: '/login' });
                console.log('触发404重新登录！');
            }
        } else if (response.data.code == 405) {
            const token = sessionStorage.getItem('timestamp');
            if (token) {
                console.log('触发405重新登录！', store.state.HomeInfo.is_purchase_enabled);
                if (store.state.HomeInfo.is_purchase_enabled) {
                    ElementUI.Message({
                        message: '请购买资源后再访问！',
                        type: 'err'
                    });
                    if (isMobile()) { //跳转到资源购买页面
                        router.push({ path: '/purchase' });
                    } else {
                        router.push({ path: '/resourcebuy' });
                    }

                } else {
                    ElementUI.Message({ //跳转到个人中心页面
                        message: '请联系学校管理员开通资源！',
                        type: 'err'
                    });
                    if (isMobile()) {
                        router.push({ path: '/profilepage' });
                    } else {
                        router.push({ path: '/personalcenter' });
                    }

                }

            } else {
                router.push({ path: '/login' });
            }
        } else {
            return response
        }
    },
    (error) => {
        if (error.response && error.response.status === 500) {
            // 状态码为 500 时，显示自定义错误信息
            ElementUI.Message({
                message: '服务器开小差啦，请稍后再试~',
                type: 'error'
            });
        } else {
            ElementUI.Message({
                message: error.message || '请求发生未知错误',
                type: 'error'
            });
        }
    });

// 添加请求拦截器
axios.interceptors.request.use(config => {
    const key = sessionStorage.getItem('key');
    if (key) {
        config.headers['key'] = key;
    }
    return config;
}, error => {
    return Promise.reject(error);
});



// 初始化key
const initKey = async() => {
    const currentPath = window.location.pathname;
    const firstSegment = currentPath.split('/')[2] || '';
    console.log('main当前项目名：' + firstSegment);
    try {
        const response = await httphostCheck(firstSegment);
        console.log('httphostCheck 响应:', response);
        if (response.code === 200) {
            if (sessionStorage.getItem('firstSegment') !== firstSegment) {
                sessionStorage.clear();
                return;
            }
            console.log('获取域名信息成功:', response.data);
            sessionStorage.setItem('firstSegment', firstSegment);
            sessionStorage.setItem('key', response.data.id);

        } else {
            ElementUI.Message({
                message: response.message + '即将跳转到主站',
                type: 'err',
                duration: 1200,
            });
            sessionStorage.setItem('key', '1');
            setTimeout(() => {
                window.location.href = '/web/kmsm/';
            }, 1200)
        }

    } catch (error) {
        console.log('获取域名信息失败:', error);
        sessionStorage.setItem('key', '1');
    }
}
initKey().then(() => {
    new Vue({
        el: '#app',
        router,
        store, //使用store vuex状态管理
        components: { App },
        template: '<App/>',
        data: {
            Bus: new Vue()
        },
    })
}).catch(error => {
    console.log('应用初始化失败:', error);
});